module.exports = __webpack_public_path__ + "img/introduction02_workContents_01.97afad69.png";